import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Swal from "sweetalert2";

import { Link } from "react-router-dom";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayoutLanding from "layouts/authentication/components/BasicLayoutLanding";
import { useMaterialUIController } from "context";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";
import authService from "services/auth-service";

function ForgotPassword() {
  const [isDemo, setIsDemo] = useState(false);
  const [input, setEmail] = useState({
    email: "",
  });
  const [error, setError] = useState({
    err: false,
    textError: "",
  });
  const [loading, setLoading] = useState(false);

  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  useEffect(() => {
    setIsDemo(process.env.REACT_APP_IS_DEMO === "true");
  }, []);

  const changeHandler = (e) => {
    setEmail({
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (input.email.trim().length === 0 || !input.email.trim().match(mailFormat)) {
      setError({ err: true, textError: "O e-mail deve ser válido" });
      return;
    }

    setLoading(true);

    // somthing not right with the data
    const myData = {
      redirect_url: `${window.location.origin}/auth/reset-password`,
      email: input.email,
    };

    try {
      if (isDemo == false) {
        const response = await authService.forgotPassword(myData);
        setError({ err: false, textError: "" });
        Swal.fire({
          icon: "success",
          title: "E-mail enviado!",
          text: "Por favor, verifique seu e-mail para redefinir sua senha.",
        });
      } else {
        Swal.fire({
          icon: "warning",
          text: "Você não pode atualizar a senha na versão de demonstração",
        });
      }
    } catch (err) {
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        if (err.errors.hasOwnProperty("email")) {
          setError({ err: true, textError: err.errors.email[0] });
        } else {
          setError({ err: true, textError: "Ocorreu um erro" });
        }
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayoutLanding coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow={sidenavColor}
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Redefinir Senha
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Você receberá um e-mail em no máximo 60 segundos
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" method="POST" onSubmit={handleSubmit}>
            <MDBox mb={4}>
              <MDInput
                type="email"
                label="E-mail"
                variant="standard"
                fullWidth
                value={input.email}
                name="email"
                onChange={changeHandler}
                error={error.err}
              />
            </MDBox>
            {error.err && (
              <MDTypography variant="caption" color="error" fontWeight="light">
                {error.textError}
              </MDTypography>
            )}
            <MDBox mt={6} mb={1}>
              <MDButton variant="gradient" color={sidenavColor} fullWidth type="submit" disabled={loading}>
                {loading ? "Enviando..." : "Redefinir"}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Já tem uma conta?{" "}
                <MDTypography
                  component={Link}
                  to="/auth/login"
                  variant="button"
                  color={sidenavColor}
                  fontWeight="medium"
                  textGradient
                >
                  Entrar
                </MDTypography>
              </MDTypography>
            </MDBox>
            <MDBox mt={2} mb={1} textAlign="center">
              <MDTypography variant="caption" color="text">
                Ao continuar, você concorda com nossos{" "}
                <a href="https://djparafestas.com.br/termos-uso" target="_blank" style={{ color: "inherit", textDecoration: "underline" }}>
                  Termos de Uso
                </a>
                {" "}e{" "}
                <a href="https://djparafestas.com.br/politica-de-privacidade" target="_blank" style={{ color: "inherit", textDecoration: "underline" }}>
                  Política de Privacidade
                </a>.
              </MDTypography>
            </MDBox>
            {/* <MDBox mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Não tem uma conta?{" "}
                <MDTypography
                  component={Link}
                  to="/auth/register"
                  variant="button"
                  color={sidenavColor}
                  fontWeight="medium"
                  textGradient
                >
                  Cadastre-se
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayoutLanding>
  );
}

export default ForgotPassword;
